module.exports = __webpack_public_path__ + "static/img/case_17.5618b2e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_17.jpg
// module id = f2Nw
// module chunks = 0